import Api from '@/wrapper'
import { setProduct } from '@core/plugins/vuetify/theme/theme.helper'
import { useEnv } from '@/composables/env/useEnv'

export const api = Api(useEnv().inferApiUrl.value, setProduct(window.location.hostname))
